<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.867"
    height="16.849"
    viewBox="0 0 16.867 16.849"
  >
    <path
      id="Pencil_Icon"
      data-name="Pencil Icon"
      d="M370.268,829.93l-2.631-2.627a1.633,1.633,0,0,0-2.3-.027l0,0h0l-9.593,9.577-.193.191-1.66,6.619,6.623-1.659.619-.628h0l9.164-9.151h0l0,0A1.626,1.626,0,0,0,370.268,829.93Zm-14.04,7.783,3.621,3.614-3.4.851-1.061-1.116Zm4.286,1.377-2.053-2.05,6.874-6.862,2.053,2.05Z"
      transform="translate(-353.888 -826.816)"
      :fill="color"
    />
  </svg>
</template>

<script>
  export default {
    name: 'EditIcon',
    props: {
      color: {
        type: String,
        default: '#024731',
      },
    },
  }
</script>

<style scoped>
  svg {
    width: 16.867px;
    height: 16.849px;
  }
  svg path {
    transition: all 0.3s ease-in-out;
  }
  svg:hover {
    transform: rotate(45deg) scale(1.1);
  }
  /* svg:hover path {
        fill: #592892 !important;
    } */
</style>
